import React from "react";
import TopBar from "./topBar";
import SideBar from "./sideBar";
import Footer from "./footer";

export default function Layout({children}) {
    return (
        <React.Fragment>
            {/* Layout wrapper */}
            <SideBar/>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    {/* Layout container */}
                    <div className="layout-page">
                        {/* Navbar */}
                        {/* Content wrapper */}
                        <div className="content-wrapper bg-footer-theme">
                        <TopBar/>
                            {/* Content */}
                            {children}
                            <Footer/>
                            <div className="content-backdrop fade"></div>
                        </div>
                        {/* Content wrapper */}
                    </div>
                    {/* / Layout page */}
                </div>

                {/* Overlay */}
                <div className="layout-overlay layout-menu-toggle"></div>
            </div>
            {/* / Layout wrapper */}

        </React.Fragment>
    )
}